// libs
import React from 'react';
import cx from 'classnames';
// widgets
import Table from '@/widgets/Table';
import { KeywordMatchType } from '@local/typedefs/dist/protos/campaign/Criteria';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { columns } from './constants';
import { formatNumberIntl, prefixWithRupee } from '@/helpers/utils';
import { getParsedMetricValue } from '@/helpers/utils';
// styles
import style from '@/widgets/Table/Table.module.scss';
import keywordStyle from './KeywordTable.module.scss';
const NON_DIGIT_REGEX = /[^\d.-]/g;
const transformKeywordToTable = (keywordData) => {
    const tableData = [];
    keywordData.forEach((keyword) => {
        var _a, _b, _c, _d, _e;
        tableData.push({
            keyword: keyword.keywordText,
            bidAmount: prefixWithRupee(getParsedMetricValue(formatNumberIntl({
                value: keyword.bid,
            }))),
            matchType: getMatchType(keyword.matchType),
            spend: prefixWithRupee(getParsedMetricValue(formatNumberIntl({
                value: (_a = keyword.metrics) === null || _a === void 0 ? void 0 : _a.budgetBurnt,
            }))),
            impressions: getParsedMetricValue(formatNumberIntl({
                value: (_b = keyword.metrics) === null || _b === void 0 ? void 0 : _b.impressions,
            })),
            addToCart: getParsedMetricValue(formatNumberIntl({
                value: (_c = keyword.metrics) === null || _c === void 0 ? void 0 : _c.addToCart,
            })),
            gmv: prefixWithRupee(getParsedMetricValue(formatNumberIntl({
                value: (_d = keyword.metrics) === null || _d === void 0 ? void 0 : _d.gmv,
            }))),
            roi: getParsedMetricValue(formatNumberIntl({
                value: (_e = keyword.metrics) === null || _e === void 0 ? void 0 : _e.roi,
                maximumFractionDigits: 2,
            })),
        });
    });
    return tableData;
};
const getMatchType = (matchType) => {
    switch (matchType) {
        case KeywordMatchType.KEYWORD_MATCH_TYPE_BROAD:
            return 'Broad Match';
        case KeywordMatchType.KEYWORD_MATCH_TYPE_EXACT:
            return 'Exact Match';
        case KeywordMatchType.KEYWORD_MATCH_TYPE_INVALID:
            return 'Invalid';
        default:
            return '';
    }
};
const KeywordTable = ({ keywordData }) => {
    if (!keywordData)
        return null;
    const getInitialState = () => transformKeywordToTable(keywordData);
    const [tableData, setTableData] = React.useState(getInitialState);
    const sortHandler = (sortData) => {
        const newData = [...tableData];
        if (sortData.sortBy === 'keyword')
            newData.sort((a, b) => a.keyword.localeCompare(b.keyword));
        else {
            newData.sort((a, b) => {
                var _a, _b;
                const aValue = parseFloat((_a = a[sortData.sortBy]) === null || _a === void 0 ? void 0 : _a.replace(NON_DIGIT_REGEX, '')) || 0;
                const bValue = parseFloat((_b = b[sortData.sortBy]) === null || _b === void 0 ? void 0 : _b.replace(NON_DIGIT_REGEX, '')) || 0;
                if (sortData.descending) {
                    return bValue - aValue;
                }
                else {
                    return aValue - bValue;
                }
            });
        }
        setTableData([...newData]);
    };
    const getText = (text) => {
        return (React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, color: DlsColorTokens.text_Med_Emphasis }, text));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Table, { classNames: {
                container: keywordStyle.table,
            }, columns: columns, data: tableData, renderRow: (row, index) => {
                return (React.createElement("ul", { className: cx(style.tableRow, style.rowList) },
                    React.createElement("li", { style: { width: columns[0].width }, className: keywordStyle.leftAligned }, getText(row.keyword)),
                    React.createElement("li", { style: { width: columns[1].width } }, getText(row.bidAmount)),
                    React.createElement("li", { style: { width: columns[2].width } }, getText(row.matchType)),
                    React.createElement("li", { style: { width: columns[3].width } }, getText(row.spend)),
                    React.createElement("li", { style: { width: columns[4].width } }, getText(row.impressions)),
                    React.createElement("li", { style: { width: columns[5].width } }, getText(row.addToCart)),
                    React.createElement("li", { style: { width: columns[6].width } }, getText(row.gmv)),
                    React.createElement("li", { style: { width: columns[7].width } }, getText(row.roi))));
            }, onSort: sortHandler, showHeader: true })));
};
export default KeywordTable;
